import React, { useCallback, useEffect, useState } from "react";

import { getAllCrops, getSettings, updateSettings } from "services";

import { incomplete, useCancelAsyncOnUnmount } from "utils";

import { AdminHead, AdminSection, Button, Col, Form, MainPage, Option, Row, Select, Message as message } from "components";

export const ModulesConfiguration = () => {
  const [distances, setDistances] = useState(null);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState(null);
  const [crops, setCrops] = useState([]);
  const signal = useCancelAsyncOnUnmount()();

  const loadCrops = useCallback(() => {
    getAllCrops({
      signal,
    }).then((res) => {
      setCrops(res);
    });
  }, [signal]);

  const loadSettings = useCallback(() => {
    getSettings({
      signal,
    })
      .then((res) => {
        setSettings(res);
        setDistances(JSON.parse(res.hpCalcsDistances));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const complete = () => {
    updateSettings({
      ...settings,
      hpCalcsDistances: JSON.stringify(distances),
      signal,
    }).then(() => {
      message({
        content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
        icon: "gremlin",
      });
    });
  };

  const handleChange = (v) => {
    const settingsKeys = Object.keys(settings);
    const vKey = Object.keys(v)[0];

    if (settingsKeys.includes(vKey)) {
      setSettings({ ...settings, ...v });
    } else {
      const newValues = {
        short: {
          dung: v.shortDung || distances.short.dung,
          manure: v.shortManure || distances.short.manure,
        },
        medium: {
          dung: v.mediumDung || distances.medium.dung,
          manure: v.mediumManure || distances.medium.manure,
        },
        long: {
          dung: v.longDung || distances.long.dung,
          manure: v.longManure || distances.long.manure,
        },
        veryLong: {
          dung: v.veryLongDung || distances.veryLong.dung,
          manure: v.veryLongManure || distances.veryLong.manure,
        },
      };

      setDistances(newValues);
    }
  };

  useEffect(() => {
    loadSettings();
    loadCrops();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead headline="Update module settings" link="/programs/modules" tooltipText="Back to modules" description="Update global settings for modules" />
      <Row className="midi-form">
        <Col>
          <Form name="ModulesConfiguration" onFinish={(v) => complete(v)} onFinishFailed={incomplete} onValuesChange={(v) => handleChange(v)}>
            <AdminSection
              headline="Module selector parameters"
              description="These are the global settings for the module selector and calculator. There are module specific factors inside the edit page of each individual module."
            />
            <Row>
              <Col sm={12}>
                <p>Default crop 1</p>
                <Select name="hpDefaultCrop1" label="Default crop 1" initialValue={settings && settings.hpDefaultCrop1 && settings.hpDefaultCrop1}>
                  {crops &&
                    crops.length > 0 &&
                    crops.map((crop, i) => (
                      <Option value={crop.id} key={i}>
                        {crop.name}
                      </Option>
                    ))}
                </Select>
              </Col>
              <Col sm={12}>
                <p>Default crop 2</p>
                <Select name="hpDefaultCrop2" label="Default crop 2" initialValue={settings && settings.hpDefaultCrop2 && settings.hpDefaultCrop2}>
                  {crops &&
                    crops.length > 0 &&
                    crops.map((crop, i) => (
                      <Option value={crop.id} key={i}>
                        {crop.name}
                      </Option>
                    ))}
                </Select>
              </Col>
            </Row>
            <Row className="margin-top-200">
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Update module settings
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </MainPage>
  );
};
